<template>
  <div class="FpDiscountBox">
    <div class="FpDiscountBox_header">
      <span class="discount-tips" v-if="cartDetails.promotions.length < 1">
        {{ $t('shopping_cart.applyDiscount.tips', 'Have a discount code?') }}
      </span>
      <!-- <span class="discount-tips" v-if="cartDetails.promotions.length >= 1">
        {{ $t('shopping_cart.applyDiscount.subTips', 'Have another discount code?') }}
      </span> -->
      <div v-if="cartDetails.promotions.length < 1">
        <a
          @click="addDiscountBox()"
        >
          <app-icon :name="name" />
        </a>
      </div>
    </div>
    <div class="FpDiscountBox_content" v-if="showDiscountBox">
      <form class="discount-apply">
        <app-text-input
          :label="$t('shopping_cart.applyDiscount.label', 'Discount/voucher code')"
          autofocus="autofocus"
          v-model.trim="promotionCode"
        />
        <app-button
          type="submit"
          class="button-discount"
          @click.prevent="applyDiscountCode.run(promotionCode)"
          :disabled="!promotionCode"
        >
          {{ $t('shopping_cart.applyDiscount.button.apply', 'Apply') }}
        </app-button>
      </form>
      <p class="tip-error" v-if="errorTips">
        {{ errorMessage }}
      </p>
      <p class="tip-error" v-if="dulicateError">
        {{ $t('validation.error.message.applyPromotionIsDuplicated', "The code you're trying to use is duplicated") }}
      </p>
    </div>

    <app-spinner :rhombus-size="rhombusSize" :color="color" v-if="loading || repeadLoading"/>
    <ul class="discountCodeLists">
      <li v-for="(item, index) in cartDetails.promotions" :key="index">
        <div class="applyPromotion">
          <app-icon name="check-mark"/>
          <div class="discountCode">
            <p class="promotionCode">
              <span>{{ item.code }}</span>
              <button
                class="Product_btn-remove"
                @click.prevent="removePromotionCode.run(item.code)"
              >
                {{ $t('shopping_cart.applyDiscount.button.remove', 'Remove') }}
              </button>
            </p>
            <p class="description">{{ item.description }}</p>
          </div>
        </div>
        <p class="tip-applied">
          {{ $t('shopping_cart.applyDiscount.succcess.message', 'Has been applied to') }}
          <b>{{ item.appliedQuantity }}</b>
          <span v-if="item.appliedQuantity===1">
            {{ $t('shopping_cart.applyDiscount.succcess.subMessage', 'bundle') }}
          </span>
          <span v-if="item.appliedQuantity>1">
            {{ $t('shopping_cart.applyDiscount.succcess.subMessages', 'bundles') }}
          </span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
  import { extractErrorMessage } from '@/utilities/common'
  import { remove, drop, includes, flattenDepth } from 'lodash'
  import { mapState } from 'vuex'

  export default {
    name: 'fp-discount-box',

    data () {
      return {
        name: 'fp-plus',
        promotionCode: null,
        errorTips: false,
        loading: false,
        promotions: null,
        errorMessage: null,
        dulicateError: false,
        storedCartItems: JSON.parse(window.sessionStorage.getItem('storedCartItems'))
      }
    },

    props: {
      bundlesWithQuantity: {
        type: Array,
        default () {
          return []
        }
      },
      color: {
        type: String,
        default: '#9b9b9b'
      },
      rhombusSize: {
        type: Number,
        default: 10
      },
      repeadLoading: {
        type: Boolean,
        default: false
      },
      previewBundle: {
        type: Array,
        default: function () {
          return []
        }
      }
    },

    computed: {
      ...mapState('checkout', {
        cartDetails: state => state.cartDetails
      }),

      ...mapState('culture', ['isDisplayTax']),

      showDiscountBox () {
        if (this.name === 'fp-minus') {
          return true
        } else {
          return false
        }
      },

      bundlesWithPromotions () {
        return this.cartDetails.groups.map(group => {
          return group.items.map(item => ({
            name: item.name,
            quantity: item.quantity,
            promotions: item.promotions
          }))
        })
      }
    },

    methods: {
      addDiscountBox () {
        if (this.name && this.name === 'fp-minus') {
          this.trackConversion({
            name: 'interaction',
            description: 'discount_voucher:close'
          })
          this.name = 'fp-plus'
        } else {
          this.trackConversion({
            name: 'interaction',
            description: 'discount_voucher:open'
          })
          this.name = 'fp-minus'
          this.errorTips = false
          this.dulicateError = false
        }
      }
    },

    tasks (t) {
      return {
        applyDiscountCode: t(async function (promotionCode) {
          this.loading = true
          const removeDulicatePromotion = includes(this.bundlesWithQuantity[0].promotionCodes, promotionCode)
          this.bundlesWithQuantity.map(bundles => {
            bundles.promotionCodes.unshift(promotionCode)
          })
          if (removeDulicatePromotion) {
            this.loading = false
            this.dulicateError = true
            this.errorTips = false
            this.name = 'fp-minus'
            this.bundlesWithQuantity.map(bundles => {
              bundles.promotionCodes = drop(bundles.promotionCodes, 1)
            })
            this.promotionCode = null
          } else {
            const zipCodeForTaxEstimation = window.localStorage.getItem('currentEstimatedZipCode')
            this.$store.commit('checkout/setSubscriptionIsPreviewing', true)
            this.$store.dispatch('checkout/getCartDetails', {
              bundles: this.bundlesWithQuantity,
              excludePrice: false,
              zipCode: zipCodeForTaxEstimation
            }).then((data) => {
              this.name = 'fp-plus'
              this.dulicateError = false
              this.$store.commit('checkout/setCartDetails', data)
              this.loading = false
              if (this.cartDetails.promotions.length === 1) {
                this.trackConversion({
                  name: 'checkout_voucher',
                  description: 'success',
                  vouchercode: promotionCode
                })
              } else {
                this.trackConversion({
                  name: 'checkout_voucher',
                  description: 'success',
                  vouchercode: `${promotionCode}:add`
                })
              }
              window.sessionStorage.setItem('storedCartItems', JSON.stringify(this.bundlesWithQuantity))
              window.sessionStorage.setItem('bundlesWithPromotions', JSON.stringify(flattenDepth(this.bundlesWithPromotions), 1))
              this.errorTips = false
              this.promotionCode = null
              this.$store.commit('checkout/setSubscriptionIsPreviewing', false)
            }).catch(error => {
              this.loading = false
              this.errorTips = true
              this.dulicateError = false
              this.trackConversion({
                name: 'checkout_voucher',
                description: 'failed',
                vouchercode: promotionCode
              })
              this.bundlesWithQuantity.map(bundles => {
                bundles.promotionCodes = drop(bundles.promotionCodes, 1)
              })
              this.errorMessage = extractErrorMessage(error)
              this.promotionCode = null
              this.$notify({
                type: 'error',
                title: extractErrorMessage(error)
              })
              this.$store.commit('checkout/setSubscriptionIsPreviewing', false)
            })
          }
        }),

        removePromotionCode: t(async function (promotionCode) {
          this.trackConversion({
            name: 'interaction',
            description: `${promotionCode}:remove`
          })
          remove(this.bundlesWithQuantity, item => {
            remove(item.promotionCodes, promotion => promotion === promotionCode)
          })
          this.loading = true
          this.$store.commit('checkout/setSubscriptionIsPreviewing', true)
          const zipCodeForTaxEstimation = window.localStorage.getItem('currentEstimatedZipCode')
          this.$store.dispatch('checkout/getCartDetails', {
            bundles: this.bundlesWithQuantity,
            excludePrice: false,
            zipCode: zipCodeForTaxEstimation
          }).then((data) => {
            this.$store.commit('checkout/setCartDetails', data)
            this.loading = false
            window.sessionStorage.setItem('storedCartItems', JSON.stringify(this.bundlesWithQuantity))
            window.sessionStorage.setItem('bundlesWithPromotions', JSON.stringify(flattenDepth(this.bundlesWithPromotions), 1))
            this.errorTips = false
            this.name = 'fp-plus'
            this.promotionCode = null
            this.$store.commit('checkout/setSubscriptionIsPreviewing', false)
          }).onError(function (task) {
            this.bundlesWithQuantity.map(bundles => {
              bundles.promotionCodes.push(promotionCode)
            })
            this.$notify({
              type: 'error',
              title: extractErrorMessage(task.error)
            })
          })
        })
      }
    },

    created () {
      const zipCodeForTaxEstimation = window.localStorage.getItem('currentEstimatedZipCode')
      try {
        if (this.storedCartItems) {
          this.$store.dispatch('checkout/getCartDetails', {
            bundles: this.storedCartItems,
            excludePrice: false,
            zipCode: zipCodeForTaxEstimation
          }).then((data) => {
            this.$store.commit('checkout/setCartDetails', data)
          })
        }
      } catch (error) {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      }
    }
  }
</script>

<style lang="scss">
  .FpDiscountBox {
    position: relative;

    &_header {
      display: flex;
      justify-content: space-between;
      padding: .23rem 0 .07rem;

      .discount-tips {
        color: $blue;
        font-weight: 400;
      }
    }

    .AppSpinner {
      margin-top: .2rem;
      left: 50%;
    }

    &_content {
      .discount-apply {
        display: flex;
        justify-content: space-between;
        padding: .08rem .12rem;
        border: .01rem solid #000;

        .Form_group {
          margin-bottom: 0;

          .Form_label {
            font-size: .12rem;
            color: #787878;
            font-weight: 400;
            line-height: .16rem;
          }

          .Form_control {
            border: none;
            font-size: .16rem;
            line-height: .22rem;
            font-weight: 400;
            color: #212121;
            padding: 0;
          }
        }

        .AppButton {
          background: none;
          color: $blue;
          font-size: .14rem;
          line-height: .24rem;
          width: auto;
        }

        .disabled {
          background: none !important;
        }
      }
    }

    .discountCodeLists {
      margin-top: .1rem;

      .applyPromotion {
        display: flex;

        .icon-check-mark {
          width: .17rem;
          height: .12rem;
          margin: .06rem .17rem 0 0;
        }

        .discountCode {
          width: 90%;

          .promotionCode {
            display: flex;
            justify-content: space-between;

            span {
              font-size: .16rem;
              line-height: .24rem;
              color: #212121;
            }

            .Product_btn-remove {
              right: 0;
              font-weight: 500;
              font-size: .14rem;
              line-height: .24rem;
              color: #0066a1;
            }
          }

          .description {
            font-size: .14rem;
            color: #787878;
            line-height: .21rem;
          }
        }
      }

      .tip-applied {
        color: #499c00;
        padding: .05rem .1rem;
      }
    }
  }
</style>
